import React, { Component } from 'react';
import styles from './UserProfileCard.module.css';

class UserProfileCard extends Component {

    render() {
        const { userData } = this.props;
        return (
            <div className={styles.profileContainer} >
                <div className={styles.profileHeader}>
                    <div className={styles.profilePicture}>
                        <img src={userData.avatar} alt="Profile" />
                    </div>
                    <p>{userData.realmUser?.firstName + ' ' + userData.realmUser?.lastName}</p>
                </div>

                <div className={styles.profileDetails}>
                    <div className={styles.detailsSection}>
                        <h3>Personal Information</h3>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Title:</span>
                            <span className={styles.detailValue}>{userData.title}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>First name:</span>
                            <span className={styles.detailValue}>{userData.realmUser.firstName}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Last name:</span>
                            <span className={styles.detailValue}>{userData.realmUser.lastName}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Designation:</span>
                            <span className={styles.detailValue}>{userData.realmUser.attributes.designation}</span>
                        </div>
                    </div>
                    <div className={styles.detailsSection}>
                        <h3>Contact Details</h3>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Email:</span>
                            <span className={styles.detailValue}>{userData.realmUser.email}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Cellphone:</span>
                            <span className={styles.detailValue}>{userData.realmUser.attributes.cellphone}</span>
                        </div>
                        <div className={styles.detailItem}>
                            <span className={styles.detailLabel}>Work phone:</span>
                            <span className={styles.detailValue}>{userData.realmUser.attributes.workphone}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
export default UserProfileCard;
